import styled from 'styled-components';

import { Card, CardInspire } from '@xing-com/card';
import {
  scale080,
  scale090,
  scale100,
  scale110,
  scale140,
  spaceL,
  spaceM,
  spaceS,
  spaceXS,
  xdlColorPremiumTertiary,
  xdlColorText,
} from '@xing-com/tokens';
import { Headline, Hero } from '@xing-com/typography';

const ArticlePaywallContainer = styled.div<{ topOffset?: number }>`
  align-items: flex-start;
  display: flex;
  inset: 0;
  justify-content: center;
  margin: -5px -10px;
  position: absolute;
  top: ${({ topOffset }) => topOffset ?? 0}px;

  &::before {
    content: '';
    backdrop-filter: blur(4px);
    inset: 0;
    position: absolute;
  }
`;

const PaywallCard = styled(Card)`
  border-radius: ${spaceS};
  padding: ${scale140} ${scale110} ${scale110};
`;

const AuthorProfile = styled.div`
  display: flex;
  gap: ${scale100};
  margin-bottom: ${spaceL};
`;

const ArticleAuthorTitle = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: ${spaceXS};
`;

const ArticleHeadline = styled(Hero)`
  font-size: ${scale090};
  line-height: ${scale080};
  margin: 0;
`;

const ArticleAuthorLink = styled.a`
  color: ${xdlColorText};
  margin-right: ${spaceM};
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

const ArticleAuthorName = styled(Headline)`
  margin: 0;
  font-weight: 400;
`;

const InnerCard = styled(CardInspire)`
  background-color: ${xdlColorPremiumTertiary};
  border-radius: ${spaceS};
  padding: ${scale100};

  > div {
    align-items: flex-start;
  }
`;

const InnerCardHeadline = styled(Hero)`
  margin-top: ${spaceM};
`;

export const Styled = {
  ArticlePaywallContainer,
  PaywallCard,
  AuthorProfile,
  ArticleAuthorLink,
  ArticleAuthorName,
  ArticleHeadline,
  ArticleAuthorTitle,
  InnerCard,
  InnerCardHeadline,
};
